import './AdminPage.css';
import React, { useState } from 'react';
import { Tabs, Tab, Box, Typography } from '@mui/material';
import UsersOverview from '../components/UsersOverview';
import SchoolProfilesOverview from '../components/SchoolProfilesOverview';
import UserRolesManagement from '../components/UserRolesManagement';
import EmailVerification from '../components/EmailVerification';
import SchoolProfileVerification from '../components/SchoolProfileVerification';
import PrintJobsManagement from '../components/PrintJobsManagement';
import UserManual from '../components/UserManual';
import DraftsManagement from '../components/DraftsManagement';
import DiscountManagement from '../components/DiscountManagement';

const AdminPage = () => {
  const [selectedTab, setSelectedTab] = useState(0); // Tab-State für die Tabs-Komponente

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue); // Setze den aktiven Tab
  };

  return (
    <Box
      sx={{
        padding: '2rem',
        maxWidth: '1300px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      <Box sx={{ border: '1px solid #ccc', borderRadius: '8px', mt: 1.4 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '50px',
            borderBottom: '2px solid #e0e0e0',
            backgroundColor: '#f9f9f9',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: '#333',
              letterSpacing: '0.5px'
            }}
          >
            Adminbereich
          </Typography>
        </Box>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          aria-label="admin page tabs"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{ mr: '1rem' }} 
        >
          <Tab label="Benutzer" />
          <Tab label="Schulprofile" />
          <Tab label="Benutzerrollen" />
          <Tab label="E-Mail Verifizierung" />
          <Tab label="Schulprofil Verifizierung" />
          <Tab label="Entwürfe" />
          <Tab label="Druckaufträge" />
          {/* <Tab label="Benutzungsanleitungen" /> */}
          <Tab label="Rabatt" />
        </Tabs>
      </Box>

      {selectedTab === 0 && <UsersOverview />}
      {selectedTab === 1 && <SchoolProfilesOverview />}
      {selectedTab === 2 && <UserRolesManagement />}
      {selectedTab === 3 && <EmailVerification />}
      {selectedTab === 4 && <SchoolProfileVerification />}
      {selectedTab === 5 && <DraftsManagement />}
      {selectedTab === 6 && <PrintJobsManagement />}
      {/* {selectedTab === 7 && <UserManual />} */}
      {selectedTab === 7 && <DiscountManagement />}
      </Box>
    </Box>
  );
};

export default AdminPage;
